import { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { Input, Password } from '../Input/Input';
import { postAuthRevalidate } from '../apiCalls';

const DEFAULT_ERROR_MESSAGE = 'Authentication failed. Please check your credentials.';
const AuthModal = ({
  show,
  onHide = () => {},
  onSuccess = () => {},
  title = 'Confirm VAT Override',
  mainMessage = 'You are attempting to override restricted VAT settings.',
  instructionMessage = 'Please enter your password to confirm these changes.',
  isLoading = false,
}) => {
  const email = sessionStorage.getItem('name');
  const [username, setUsername] = useState(email);
  const [password, setPassword] = useState('');

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async () => {
    setLoading(true);
    setErrorMessage('');
    try {
      const response = await postAuthRevalidate({
        username: username,
        password: password,
      });

      if (response?.success === true) {
        onSuccess();
        setErrorMessage('');
      } else {
        setErrorMessage(response?.err || DEFAULT_ERROR_MESSAGE);
      }
    } catch {
      setErrorMessage(DEFAULT_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setLoading(false);
    setErrorMessage('');
    setPassword('');

    onHide();
  };

  return (
    <Modal className="qa-checklist-modal" animation={false} show={show} size="md" centered onHide={handleCancel}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={handleCancel} />
      </Modal.Header>
      <Modal.Body>
        <div>
          <div>{mainMessage}</div>
          <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>{instructionMessage}</div>
          <div style={{ paddingTop: '15px', paddingBottom: '15px' }}>
            <Input
              name="username"
              type="text"
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              hideLabel={true}
              disabled
            />
          </div>
          <Password
            name="password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={'Confirm Password'}
            hideLabel={true}
            autocomplete="new-password"
            disabled={isLoading}
          />
          <span className="text-danger">{errorMessage}&nbsp;</span>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {isLoading ? (
          <div className="w-100 d-flex justify-content-end">
            <Spinner animation="border" size="md" />
          </div>
        ) : (
          <div className="d-flex w-100 justify-content-between">
            <button className="epo-continue-button small-button" type="button" onClick={handleCancel}>
              Cancel
            </button>
            <button
              className="blue-button-newload small-button"
              type="button"
              onClick={handleSubmit}
              disabled={!password || loading}
            >
              Confirm
            </button>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default AuthModal;
